import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./UpdateExcel'))),
    path: '/lead/update',
  },
];
